<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="aCRU" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 21.3 21.8" style="enable-background:new 0 0 21.3 21.8;" xml:space="preserve">
<style type="text/css">
	.st0CRU{fill:#2684FF;}
	.st1CRU{fill:url(#SVGID_1_CRU);}
</style>
<path class="st0CRU" d="M10.6,2.3C6,2.3,2.2,3.9,2.2,5.8v0.3l1.5,7.8c0.6,3.3,3.5,5.7,6.9,5.7s6.3-2.4,6.9-5.7L19,6.1V5.8
	C19,3.9,15.3,2.3,10.6,2.3z M10.6,15.2c-2.5,0-2.2-5.7-5-6.5C5.4,8.6,5.2,8.6,5,8.4c1.5-0.6,3.4-0.9,5.6-0.9s4.1,0.3,5.6,0.9
	c-0.2,0.1-0.4,0.2-0.7,0.2C12.9,9.6,13.1,15.2,10.6,15.2z"/>
<linearGradient id="SVGID_1_CRU" gradientUnits="userSpaceOnUse" x1="10.64" y1="-796.5352" x2="10.64" y2="-790.4072" gradientTransform="matrix(1 0 0 -1 0 -788.1102)">
	<stop  offset="0" style="stop-color:#0052CC"/>
	<stop  offset="1" style="stop-color:#2684FF"/>
</linearGradient>
<path class="st1CRU" d="M5,8.4c1.5-0.6,3.5-0.9,5.7-0.9s4.2,0.3,5.7,0.9c1.7-0.7,2.9-1.6,2.9-2.7c0-2-3.8-3.6-8.5-3.6S2.1,3.8,2.1,5.8
	C2.1,6.9,3.2,7.8,5,8.4z"/>
</svg>
